import { Component, OnInit, Input } from '@angular/core';
import { PaylocService } from '../services/payloc.service';
import { AppNavigationService } from '../../service/app-navigation.service';
import {AuthService} from "../../auth/auth.service";
import {Observable} from "rxjs/index";
import { Option } from '../../dropdowns/models/option.model';
import {DropdownService} from "../../dropdowns/dropdown.service";

@Component({
  selector: 'app-payloc-menu',
  templateUrl: './payloc-menu.component.html',
  styleUrls: ['./payloc-menu.component.css']
})
export class PaylocMenuComponent implements OnInit {

  public isPaylocSearchSectionCollapsed = false;
  public isPaylocFilterCollapsed = false;

  public memberLevelList$: Observable<Option[]>;

  constructor(
    private navService: AppNavigationService,
    private service: PaylocService,
    private authService: AuthService,
    private dropdownService: DropdownService
  ) { }

  ngOnInit() {
    this.memberLevelList$ = this.dropdownService.getAllMemberLevels();
  }

  public onSearchClicked(page: number): void {
    this.displayFilterTokens();
    this.service.getPaylocs(page);
    window.scroll(0, 0);
    this.navService.goToPaylocList();
  }

  public onResetClicked(): void {
    this.service.resetFilters();
    this.service.hasSearched = false;
    this.service.hasSearchResults = false;
    this.focusFirstAgencyFilter();
  }

  private focusFirstAgencyFilter(): void {
  }

  public onValueChange(value: string): void {

    this.toggleSearchableState();
  }

  public onValueChangeDropdown(value: string, label: string): void {
    this.service.paylocSearch.memberLevelLabel = label;
    this.toggleSearchableState();
  }



  private toggleSearchableState(): void {
    // At least one filter must be entered/selected in order to search
    // TODO: These fields should be trimmed; whitespace searches should not be allowed
    this.service.canSearchFn(); // = !!this.service.payloc.customerNum || !!this.service.payloc.paymentNum;
  }

  private displayFilterTokens(): void {
    this.service.displayFilterTokens();
  }
}
